document.addEventListener("DOMContentLoaded", async () => {

    const hideBtn = document.getElementById("hideHighlight");
    const showBtn = document.getElementById("showHighlight");

    hideBtn?.addEventListener("click", () => toggleHighlight(false));
    showBtn?.addEventListener("click", () => toggleHighlight(true));

    const loader = document.getElementById("tangent-loader");
    const error = document.getElementById("tangent-error");
    const content = document.getElementById("tangent-content");

    const params = new URLSearchParams(window.location.search);
    const respId = params.get("resp_id");

    if (!respId) {
        loader.style.display = "none";
        error.style.display = "block";
        error.textContent = "Recommendation ID not found.";
        return;
    }


    try {

        const apiUrl = `https://service.tangent.ai/shopify/get-checkout-products?resp_id=${respId}&self_serve=true&multiple_recommendation_sections=true`;

        const response = await fetch(apiUrl);
        const data = await response.json();

        console.log(data);

        loader.style.display = "none";
        content.style.display = "block";

        if (hasUserSelfie(data)) {
            renderHero(data);
            if (data.selfie_id) {
                getSelfieMapping(data.selfie_id);
            }
        } else {
            hideHeroSection();
        }

        renderProducts(data);

    } catch (err) {

        console.error(err);

        loader.style.display = "none";

        error.style.display = "block";
        error.textContent = "Unable to load recommendations.";

    }

});

let tangent_facemap_data = null;

function hasUserSelfie(data) {
    return Boolean(data?.selfie_id || getSelfieSrc(data));
}

function hideHeroSection() {
    const hero = document.getElementById("tangent-hero");
    if (!hero) return;

    hero.hidden = true;
    hero.style.display = "none";
}

function showHeroSection() {
    const hero = document.getElementById("tangent-hero");
    if (!hero) return;

    hero.hidden = false;
    hero.style.display = "";
}

function getSelfieSrc(data) {
    if (data.selfie_url) return data.selfie_url;

    const html = data.selfie_html || "";
    if (!html) return "";

    const wrap = document.createElement("div");
    wrap.innerHTML = html;
    const img = wrap.querySelector("img");

    return img ? (img.getAttribute("src") || img.src || "") : "";
}

function renderHero(data) {

    const heroWrapper = document.querySelector(".hero-wrapper");
    const selfieWrapper = document.getElementById("selfie-wrapper");

    if (!hasUserSelfie(data) || !selfieWrapper) {
        hideHeroSection();
        return;
    }

    showHeroSection();
    if (heroWrapper) {
        heroWrapper.hidden = false;
        heroWrapper.style.display = "";
    }
    const selfieSrc = getSelfieSrc(data);

    selfieWrapper.innerHTML = `
        ${selfieSrc ? `
            <img
                id="selfie_img"
                src="${selfieSrc}"
                alt="Your skin analysis"
                width="440"
                height="550"
            >
        ` : ""}
        <canvas id="selfie_canvas"></canvas>
    `;

    document.getElementById("analysis-wrapper").innerHTML = `
        <div id="analysis-loading">

            <div class="analysis-title-skeleton"></div>

            <div id="analysis-bars">
                <div class="analysis-skeleton"></div>
                ...
            </div>

        </div>
    `;
}


function renderProducts(data) {

    renderProductsDescription(data);
    renderTabs(data);

}

const sectionNames = {
    section_starter: "STARTER KITS",
    section_basics: "THE BASICS",
    section_essentials: "THE ESSENTIALS",
    section_works: "THE WORKS"
};

function getOrderedSections(sections) {
    const orderedKeys = Object.keys(sectionNames);
    const extraKeys = Object.keys(sections || {}).filter(
        key => !orderedKeys.includes(key)
    );

    return [...orderedKeys, ...extraKeys].filter(
        key => Array.isArray(sections?.[key]) && sections[key].length
    );
}

function getDefaultSection(data, orderedSections) {
    const tags = Array.isArray(data.tags) ? data.tags : [];
    const hasTag = tag => tags.some(value => String(value) === tag);

    let preferred = "section_starter";

    if (hasTag("10_mins")) {
        preferred = "section_essentials";
    } else if (hasTag("15_mins+")) {
        preferred = "section_works";
    }

    if (orderedSections.includes(preferred)) {
        return preferred;
    }

    return orderedSections[0] || "";
}

function renderTabs(data) {

    const tabsContainer = document.getElementById("product-tabs");

    tabsContainer.innerHTML = "";

    const sections = data.product_sections;
    const orderedSections = getOrderedSections(sections);
    const defaultSection = getDefaultSection(data, orderedSections);

    orderedSections.forEach(section => {

        const button = document.createElement("button");

        button.className = "product-tab";

        if (section === defaultSection) {
            button.classList.add("active");
        }

        button.dataset.section = section;

        button.textContent = formatSectionName(section);

        button.addEventListener("click", () => {

            document
                .querySelectorAll(".product-tab")
                .forEach(btn => btn.classList.remove("active"));

            button.classList.add("active");

            renderProductCards(data, section);

        });

        tabsContainer.appendChild(button);

    });

    if (defaultSection) {
        renderProductCards(data, defaultSection);
    }

}

function formatSectionName(section) {
    return sectionNames[section] || section;
}

function renderProductsDescription(data) {

    const container = document.getElementById("products-description");

    if (
        data.text_sections &&
        data.text_sections.section_products &&
        data.text_sections.section_products.length
    ) {

        container.innerHTML = data.text_sections.section_products.join("");

    } else {

        container.innerHTML = "";

    }

}

function renderProductCards(data, section) {

    const grid = document.getElementById("products-grid");

    const ids = data.product_sections[section];

    const currencyMap = {
        USD: "$",
        GBP: "£",
        EUR: "€",
        AUD: "$"
    };

    const symbol = currencyMap[data.shop_info?.currency] || "$";

    let html = "";

    ids.forEach((id, index) => {

        const product = data.products.find(
            p => String(p.id) === String(id)
        );


        if (!product) return;

        const productUrl = `/products/${product.handle}`;

        const image =
            product.images?.nodes?.[0]?.url ||
            product.image?.src ||
            product.images?.[0]?.src ||
            "";

        // const variants = product.variants || [];
        const variants = product.variants?.edges?.map(edge => edge.node) || [];

        const variant =
            variants.find(v => v.available === true) ||
            variants.find(v => v.available_for_sale === true) ||
            variants[0];

        if (!variant || !variant.id) {
            console.warn("No valid variant found:", product.title);
            return;
        }

        const price = variant.price || "";

        const variantId = String(
            variant.legacyResourceId ||
            variant.id?.split("/").pop() ||
            ""
        );

        html += `
        <div class="recommendation-card">

            <div class="step-number">
                ${(index + 1).toString().padStart(2, "0")}
            </div>

            <div class="step-title">
    ${product.product_category?.value || ""}
</div>

            <a href="${productUrl}" class="product-link">
                <img
                    src="${image}"
                    alt="${product.title}"
                >
            </a>
            <button
                type="button"
                class="add-to-cart-btn"
                data-variant-id="${variantId}"
            >
                +
            </button>

            <div class="product-price">
                ${symbol}${price}
            </div>

            <div class="product-brand">Dp Dermaceuticals</div>

            <a href="${productUrl}" class="product-link">
                <h3 class="product-title">
                    ${product.title}
                </h3>
            </a>

        </div>
        `;

    });

    grid.innerHTML = html;

    attachAddToCartListeners();
}

function attachAddToCartListeners() {

    const buttons = document.querySelectorAll(".add-to-cart-btn");

    buttons.forEach(button => {

        button.addEventListener("click", async () => {

            const variantId = button.dataset.variantId;

            if (!variantId) {
                console.error("No variant ID found on button");
                return;
            }

            // Keep the button as "+"
            button.disabled = true;
            button.textContent = "+";

            try {

                const cart = document.querySelector("cart-drawer");
                const formData = new FormData();
                formData.append("id", variantId);
                formData.append("quantity", "1");

                if (cart && typeof cart.getSectionsToRender === "function") {
                    formData.append(
                        "sections",
                        cart.getSectionsToRender().map((section) => section.id)
                    );
                    formData.append("sections_url", window.location.pathname);
                    cart.setActiveElement(document.activeElement);
                }

                const response = await fetch("/cart/add.js", {
                    method: "POST",
                    headers: {
                        "X-Requested-With": "XMLHttpRequest",
                        "Accept": "application/javascript"
                    },
                    body: formData
                });

                const result = await response.json();

                if (!response.ok || result.status) {
                    console.error("Shopify cart error:", result);

                    throw new Error(
                        result.description ||
                        result.message ||
                        "Unable to add product to cart."
                    );
                }

                console.log("Product added to cart:", result);

                // Keep "+" after successful add
                button.textContent = "+";

                if (!cart) {
                    if (typeof routes !== "undefined" && routes.cart_url) {
                        window.location = routes.cart_url;
                    }
                    return;
                }

                // Publish before replacing the drawer so CartDrawerItems does
                // not fetch the cart-page section into the new drawer markup.
                if (typeof publish === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
                    publish(PUB_SUB_EVENTS.cartUpdate, {
                        source: "product-form",
                        productVariantId: variantId
                    });
                }

                if (cart.classList.contains("is-empty")) {
                    cart.classList.remove("is-empty");
                }

                cart.renderContents(result);

            } catch (error) {

                console.error("Add to cart failed:", error);

                // Keep "+" even if adding fails
                button.textContent = "+";

            } finally {

                button.disabled = false;

            }

        });

    });
}

async function getSelfieMapping(selfieId) {

    try {

        const url = `https://service.tangent.ai/shopify/upload-selfie?selfie_id=${selfieId}&user=mango`;

        const response = await fetch(url);

        if (!response.ok) {
            throw new Error(response.status);
        }

        const data = await response.json();

        tangent_facemap_data = data?.selfie_record?.[0]?.facemap;

        if (!tangent_facemap_data) return;

        renderScores(tangent_facemap_data.scores);

        // updateSelfieImage(tangent_facemap_data.url);

        // Draw face highlights
        const img = document.querySelector("#selfie_img");

        if (img) {
            img.onload = function () {
                drawOnCanvas();
                showHighlightControls();
            };
            if (img.complete && img.naturalWidth) {
                drawOnCanvas();
                showHighlightControls();
            }
            img.src = tangent_facemap_data.url;
        }

    } catch (err) {

        console.error("Selfie Mapping Error:", err);

    }

}

function drawOnCanvas() {

    if (!tangent_facemap_data) return;

    const canvas = document.querySelector("#selfie_canvas");
    const img = document.querySelector("#selfie_img");

    if (!canvas || !img) return;

    const ctx = canvas.getContext("2d");

    const imgRect = img.getBoundingClientRect();
    const wrapperRect = img.parentElement.getBoundingClientRect();

    const naturalWidth = img.naturalWidth;
    const naturalHeight = img.naturalHeight;

    const imageRatio = naturalWidth / naturalHeight;
    const boxRatio = img.clientWidth / img.clientHeight;

    let renderedWidth;
    let renderedHeight;

    if (imageRatio > boxRatio) {
        renderedWidth = img.clientWidth;
        renderedHeight = renderedWidth / imageRatio;
    } else {
        renderedHeight = img.clientHeight;
        renderedWidth = renderedHeight * imageRatio;
    }

    // Keep canvas coordinates at the original image resolution
    canvas.width = naturalWidth;
    canvas.height = naturalHeight;

    // Match canvas size to the visible image
    canvas.style.width = `${renderedWidth}px`;
    canvas.style.height = `${renderedHeight}px`;

    // Position canvas over the visible image
    canvas.style.left =
        `${imgRect.left - wrapperRect.left + (imgRect.width - renderedWidth) / 2}px`;

    canvas.style.top =
        `${imgRect.top - wrapperRect.top + (imgRect.height - renderedHeight) / 2}px`;
    canvas.style.visibility = "visible";

    // Clear previous highlights
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    const prop = naturalWidth / 400;

    drawDarkCircleContours(
        ctx,
        tangent_facemap_data.dark_circles || [],
        getDarkCircleBlur(prop)
    );

    drawWrinkleContours(
        ctx,
        tangent_facemap_data.wrinkles || [],
        getWrinkleLineWidth(prop)
    );

    drawRosaceaContours(
        ctx,
        tangent_facemap_data.rosacea || [],
        getRosaceaBlur(prop)
    );

    // drawTextureContours(
    //     ctx,
    //     tangent_facemap_data.texture || [],
    //     getTextureLineWidth(prop)
    // );

    drawDarkSpotsContours(
        ctx,
        tangent_facemap_data.darkspots || [],
        getDarkSpotsLineWidth(prop)
    );

    drawAcneContours(
        ctx,
        tangent_facemap_data.acne || [],
        getAcneLineWidth(prop)
    );
}

function showHighlightControls() {
    const controls = document.getElementById("highlight-controls");
    const hideBtn = document.getElementById("hideHighlight");
    const showBtn = document.getElementById("showHighlight");

    if (!controls || !hideBtn || !showBtn) return;

    controls.hidden = false;
    controls.classList.add("is-visible");
    hideBtn.style.display = "inline";
    showBtn.style.display = "none";
}

function toggleHighlight(show) {
    const canvas = document.getElementById("selfie_canvas");
    const hideBtn = document.getElementById("hideHighlight");
    const showBtn = document.getElementById("showHighlight");

    if (!canvas || !hideBtn || !showBtn) return;

    if (show) {
        canvas.style.display = "block";
        hideBtn.style.display = "inline";
        showBtn.style.display = "none";
    } else {
        canvas.style.display = "none";
        hideBtn.style.display = "none";
        showBtn.style.display = "inline";
    }
}

function getDarkCircleBlur(prop) {

    if (prop < 1) {
        return "blur(1px)";
    } else if (prop < 1.5) {
        return "blur(2px)";
    } else if (prop < 2) {
        return "blur(4px)";
    } else if (prop < 3) {
        return "blur(7px)";
    } else if (prop < 4) {
        return "blur(12px)";
    }
}


function getRosaceaBlur(prop) {

    if (prop < 1) {
        return "blur(4px)";
    } else if (prop < 1.5) {
        return "blur(4px)";
    } else if (prop < 2) {
        return "blur(5px)";
    } else if (prop < 3) {
        return "blur(13px)";
    } else if (prop < 4) {
        return "blur(18px)";
    }
}


function getAcneLineWidth(prop) {

    if (prop < 0.5) {
        return 2;
    } else if (prop < 1) {
        return 4;
    } else if (prop < 1.5) {
        return 7;
    } else if (prop < 2) {
        return 10;
    } else if (prop < 3) {
        return 14;
    } else if (prop < 4) {
        return 15;
    }
}


function getDarkSpotsLineWidth(prop) {

    if (prop < 1) {
        return 1;
    } else if (prop < 1.5) {
        return 6;
    } else if (prop < 2) {
        return 6;
    } else if (prop < 3) {
        return 14;
    } else if (prop < 4) {
        return 15;
    }
}


function getTextureLineWidth(prop) {

    if (prop < 0.5) {
        return 2;
    } else if (prop < 1) {
        return 3;
    } else if (prop < 1.5) {
        return 6;
    } else if (prop < 2) {
        return 10;
    } else if (prop < 3) {
        return 14;
    } else if (prop < 4) {
        return 16;
    } else {
        return 20;
    }
}


function getWrinkleLineWidth(prop) {

    if (prop < 1) {
        return 4;
    } else if (prop < 1.5) {
        return 6;
    } else if (prop < 2) {
        return 10;
    } else if (prop < 3) {
        return 15;
    } else if (prop < 4) {
        return 30;
    }
}

const drawDarkCircleContours = (context, contours, filter) => {

    context.filter = filter;
    context.fillStyle = "rgba(28, 30, 82, 0.3)";

    drawContours(
        context,
        contours,
        true,
        false
    );
};


const drawWrinkleContours = (context, contours, lineWidth) => {

    context.filter = "none";
    context.fillStyle = "rgba(24, 96, 3, 0.5)";
    context.lineWidth = lineWidth;
    context.strokeStyle = "rgba(24, 96, 3, 0.5)";

    drawContours(
        context,
        contours,
        true,
        true
    );
};


const drawRosaceaContours = (context, contours, filter) => {

    context.filter = filter;
    context.fillStyle = "rgba(206, 66, 66, 0.5)";

    drawContours(
        context,
        contours,
        true,
        false
    );
};


const drawTextureContours = (context, contours, lineWidth) => {

    context.filter = "none";
    context.lineWidth = lineWidth;
    context.strokeStyle = "rgba(186, 111, 223, 0.5)";

    drawContours(
        context,
        contours,
        false,
        true
    );
};


const drawDarkSpotsContours = (context, contours, lineWidth) => {

    context.filter = "none";
    context.fillStyle = "rgba(81, 212, 191, 0.4)";
    context.lineWidth = lineWidth;
    context.strokeStyle = "rgba(81, 212, 191, 0.4)";

    drawContours(
        context,
        contours,
        true,
        false
    );
};


const drawAcneContours = (context, contours, lineWidth) => {

    context.filter = "none";
    context.fillStyle = "rgba(234, 220, 96, 0.4)";
    context.lineWidth = lineWidth;
    context.strokeStyle = "rgba(234, 220, 96, 0.4)";

    drawContours(
        context,
        contours,
        true,
        false
    );
};

const drawContours = (context, contours, fill, stroke) => {

    if (!Array.isArray(contours)) return;

    for (let i = 0; i < contours.length; i++) {

        drawContour(
            context,
            contours[i],
            fill,
            stroke
        );
    }
};


const drawContour = (
    context,
    contourCoordinates,
    fill = false,
    stroke = false
) => {

    if (!Array.isArray(contourCoordinates)) return;

    context.beginPath();

    for (let i = 0; i < contourCoordinates.length; i++) {

        const point = contourCoordinates[i];

        if (!point || point.length < 2) continue;

        if (i === 0) {
            context.moveTo(point[0], point[1]);
        } else {
            context.lineTo(point[0], point[1]);
        }
    }

    context.closePath();

    if (fill) {
        context.fill();
    }

    if (stroke) {
        context.stroke();
    }
};



function updateSelfieImage(url) {

    const img = document.querySelector("#selfie_img");

    if (img) {
        img.src = url;
    }

}

const concernColors = {
    wrinkles: "rgba(120, 184, 92)",
    rosacea: "#FF829B",
    dark_circles: "#A38283",
    acne: "#FFE078",
    darkspots: "#51D4BF",
    texture: "#D4A1FF"
};

function renderScores(scores) {

    if (!scores) return;

    const labels = [
        ["wrinkles", "Wrinkles"],
        ["rosacea", "Rosacea"],
        ["dark_circles", "Dark Circles"],
        ["acne", "Blemish"],
        ["darkspots", "Dark Spots"],
        ["texture", "Texture"]
    ];

    const wrapper = document.getElementById("analysis-wrapper");

    let html = `
        <h2>
            Your Custom Skin Journey & Clinical Recommendations
        </h2>

        <div id="analysis-bars">
    `;

    labels.forEach(([key, label]) => {

        if (scores[key] == null) return;

        const width = Math.max(0, Math.min(100, scores[key]));

        html += `
            <div class="analysis-row">

                <div class="analysis-label">
                    ${label.toUpperCase()}
                </div>

                <div class="analysis-progress">
                    <div
                        class="analysis-fill ${key}"
                        style="width:${width}%;
                        background-color:${concernColors[key]};
                        "
                    ></div>
                </div>

                <div class="analysis-score">
                    ${scores[key] / 10}/10
                </div>

            </div>
        `;
    });

    html += `
            <p class="analysis-footer">
                Each skin concern is scored from 1–10.<br>
                Higher scores indicate healthier skin.
            </p>
        </div>
    `;

    wrapper.innerHTML = html;
}